import { connect } from 'react-redux';
import { parseQP } from '../../utils/utils';
import {
  selectSkuCategory,
  selectRecipeDishtype,
  toggleSkuFilter,
  toggleRecipeFilter,
  applyRecipeFilters,
  applySkuFilters,
  getFilteredRecipes,
  getFilteredSkus,
} from '../actions_creators';
import {
  recipesNumFiltersCat,
  groceriesNumFiltersCat,
  recipesStrFilterCat,
  groceriesStrFilterCat,
  catByRecipeStrFilter,
  catBySkuStrFilter,
  proteinFilterCat,
  spicyLevelFilterCat,
  tagsFilterCat,
} from '../const';
import { ACTIVE_PROTEIN_TAGS, SPICY_LEVELS } from '../../constants/constants';

const QueryParamsFilters = ({
  selectSkuCategory,
  selectRecipeDishtype,
  toggleSkuFilter,
  toggleRecipeFilter,
  applyRecipeFilters,
  applySkuFilters,
  getFilteredRecipes,
  getFilteredSkus,
  recipesRoute,
}) => {
  const params = parseQP((value, filter) => {
    // in case the filter is tags we need to split the string make elements into ints:
    if (tagsFilterCat[filter] && /^[\d\,]+$/.test(value)) {
      return value.split(',').map((n) => parseInt(n));
    }
    // value string should only contain digits
    if (/^\d+$/.test(value)) {
      return parseInt(value);
    }

    return null;
  });

  const selectQPFilter = (
    catByFilter,
    stringFiltersCat,
    numFiltersCat,
    toggle
  ) => {
    for (let filter in params) {
      let filterCategory = catByFilter[filter];
      if (stringFiltersCat[filterCategory]) {
        toggle(filter, filterCategory);
      } else if (numFiltersCat[filter]) {
        toggle(params[filter], filter);
      } else if (tagsFilterCat[filter] && Array.isArray(params[filter])) {
        // toggle each protein in the array
        params[filter].forEach((value) => {
          const validProteinFilter =
            filter === proteinFilterCat && ACTIVE_PROTEIN_TAGS[value];
          const validSpicyFilter =
            filter === spicyLevelFilterCat && SPICY_LEVELS.includes(value);
          const validFilter = validProteinFilter || validSpicyFilter;
          if (validFilter) {
            toggle(value, filter);
          }
        });
      }
    }
  };

  if (recipesRoute) {
    if (params['dishtype']) selectRecipeDishtype(params['dishtype']);
    selectQPFilter(
      catByRecipeStrFilter,
      recipesStrFilterCat,
      recipesNumFiltersCat,
      toggleRecipeFilter
    );
    applyRecipeFilters();
    getFilteredRecipes();
  } else {
    if (params['category']) selectSkuCategory(params['category']);
    selectQPFilter(
      catBySkuStrFilter,
      groceriesStrFilterCat,
      groceriesNumFiltersCat,
      toggleSkuFilter
    );
    applySkuFilters();
    getFilteredSkus();
  }

  return null;
};

const mapDispatchToProps = (dispatch) => {
  return {
    selectSkuCategory: (id) => dispatch(selectSkuCategory(id)),
    selectRecipeDishtype: (id) => dispatch(selectRecipeDishtype(id)),
    toggleSkuFilter: (filter, filterCategory) =>
      dispatch(toggleSkuFilter(filter, filterCategory)),
    toggleRecipeFilter: (filter, filterCategory) =>
      dispatch(toggleRecipeFilter(filter, filterCategory)),
    applyRecipeFilters: () => dispatch(applyRecipeFilters()),
    applySkuFilters: () => dispatch(applySkuFilters()),
    getFilteredRecipes: () => dispatch(getFilteredRecipes()),
    getFilteredSkus: () => dispatch(getFilteredSkus()),
  };
};

export default connect(null, mapDispatchToProps)(QueryParamsFilters);
